import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

ModuleRegistry.registerModules([AllEnterpriseModule]);

declare global {
  interface Window {
    AG_GRID_LICENSE?: string;
  }
}

if (typeof window !== "undefined" && window.AG_GRID_LICENSE) {
  LicenseManager.setLicenseKey(window.AG_GRID_LICENSE);
}
